import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company info */}
          <div className="space-y-4">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_c75220d5-7bf0-4e63-b6e2-a67efd13071b/artifacts/1fg91nzm_6c40ab77-1b3b-4872-af23-9cb4d9636e0c.jpeg"
                alt="MC MaxClean OG Logo"
                className="h-28 w-auto object-contain bg-white rounded-lg p-3"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              Ihr professioneller Partner für Hausbetreuung, Reinigung und
              Winterdienst in Feldkirchen bei Graz.
            </p>
            <div className="flex gap-3 pt-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-[#2563EB] flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-[#2563EB] flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-[#2563EB] flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Schnelllinks</h3>
            <ul className="space-y-3">
              {[
                { name: 'Home', href: '#home' },
                { name: 'Dienstleistungen', href: '#services' },
                { name: 'Über uns', href: '#about' },
                { name: 'Kontakt', href: '#contact' }
              ].map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-[#2563EB] transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">Dienstleistungen</h3>
            <ul className="space-y-3 text-gray-400">
              <li>Hausbetreuung</li>
              <li>Winterdienst</li>
              <li>Grünflächenpflege</li>
              <li>Schneeräumung & Reinigung von Verkehrsflächen</li>
              <li>Durchführung einfacher Gartenarbeiten</li>
              <li>Entrümpelung</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#2563EB] flex-shrink-0 mt-0.5" />
                <div className="text-gray-400">
                  <div>{companyInfo.address.street}</div>
                  <div>{companyInfo.address.city}</div>
                  <div>{companyInfo.address.country}</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#2563EB] flex-shrink-0 mt-0.5" />
                <div>
                  <div className="text-gray-400 font-medium">{companyInfo.manager}</div>
                  <a
                    href={`tel:${companyInfo.phone}`}
                    className="text-gray-400 hover:text-[#2563EB] transition-colors"
                  >
                    {companyInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#2563EB] flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-[#2563EB] transition-colors break-all"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              © {currentYear} MC MaxClean OG. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <button className="hover:text-[#2563EB] transition-colors">
                Impressum
              </button>
              <button className="hover:text-[#2563EB] transition-colors">
                Datenschutz
              </button>
              <button className="hover:text-[#2563EB] transition-colors">
                AGB
              </button>
            </div>
          </div>
          <p className="text-center text-gray-500 text-xs mt-4">
            Geschäftsführung: {companyInfo.manager}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
